import { lazyQuiet } from '@/routing/lazyQuiet';

/**
 * F-0745's logo where the shell draws it, in its own chunk with its picture's API (the entry budget,
 * 2026-10-30: the two were 1.8 KB of the launch entry). The mark draws nothing while its picture is
 * read anyway, so its chunk arriving a moment later changes nothing a customer sees.
 */
export const OrganisationLogoMark = lazyQuiet(
  () => import('./OrganisationLogoMark'),
  (module) => module.OrganisationLogoMark,
);
